import { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/VideoBanner/styles.module.css';

import type { VideoBannerData } from './schema';
import Banner from '@redturtle/qubicaamf-theme/components/Blocks/commons/Banner';

interface VideoBannerProps {
  data: VideoBannerData;
  editMode?: boolean;
}

const VideoBanner = (props: VideoBannerProps) => {
  const intl = useIntl();
  const { data, editMode } = props;

  const [loadedData, setLoadedData] = useState(false);
  return (
    <Banner
      data={data}
      editMode={editMode}
      mediaContainerClassname={styles.bannerVideoContainer}
    >
      {!loadedData && data.bannerVideo && (
        <div className={styles.previewImage}>
          {intl.formatMessage(messages.preview_text)}
        </div>
      )}
      <video
        autoPlay
        preload="none"
        muted={true}
        loop
        onLoadedData={() => setLoadedData(true)}
        controls={false}
      >
        <source src={data.bannerVideo?.video_file} />
      </video>
    </Banner>
  );
};

export default VideoBanner;

const messages = defineMessages({
  preview_text: {
    id: 'preview_text',
    defaultMessage: 'Your video will appear here. Save to see your video',
  },
});
